import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useAuthStore from '../store/authStore';
import deepLinkHandler from '../utils/deeplink';

const CustomerAccess = ({ directToChat = false, directToHome = false }) => {
  const { projectId, password } = useParams();
  const navigate = useNavigate();
  const { customerAccess, user, isLoading } = useAuthStore();
  const [isAccessing, setIsAccessing] = useState(false);
  const hasAttemptedRef = useRef(false);
  
  console.log('[CustomerAccess] Component loaded with:', { projectId, password, directToChat, directToHome });

  // URL이 변경될 때마다 ref 초기화 및 딥링크 세션 초기화
  useEffect(() => {
    hasAttemptedRef.current = false;
    // 새로운 프로젝트 접속 시 딥링크 관련 세션 초기화
    sessionStorage.removeItem('deeplink_dialog_shown');
    sessionStorage.removeItem('deeplink_app_not_installed');
    sessionStorage.removeItem('deeplink_choice');
  }, [projectId, password]);
  
  // 딥링크 자동 실행 제거 - 앱으로 자동 전환하지 않음
  // 사용자가 수동으로 앱을 열거나 푸시 알림을 통해서만 앱 접근

  useEffect(() => {
    if (user) {
      // 이미 로그인된 사용자 처리
      if (directToChat) {
        console.log('[CustomerAccess] Already logged in, directToChat=true, navigating to messages tab');
        navigate(`/projects/${projectId}?tab=messages`);
      } else if (directToHome) {
        console.log('[CustomerAccess] Already logged in, directToHome=true, navigating to home');
        navigate('/');
      } else {
        console.log('[CustomerAccess] Already logged in, navigating to project detail');
        navigate(`/projects/${projectId}`);
      }
      return;
    }

    const handleAccess = async () => {
      if (!projectId || !password || hasAttemptedRef.current) {
        if (!projectId || !password && !hasAttemptedRef.current) {
          toast.error('잘못된 접근입니다.');
        }
        return;
      }

      hasAttemptedRef.current = true;
      setIsAccessing(true);
      try {
        const result = await customerAccess(projectId, password);
        if (result.success) {
          toast.success('프로젝트에 접속했습니다!', {
            toastId: 'project-access-success' // 고유 ID로 중복 방지
          });
          
          const userType = result.user?.user_type;
          
          // 로그인 후 이동 처리
          if (directToChat) {
            console.log('[CustomerAccess] directToChat=true, navigating to messages tab');
            navigate(`/projects/${projectId}?tab=messages`);
          } else if (directToHome) {
            console.log('[CustomerAccess] directToHome=true, navigating to home');
            navigate('/');
          } else {
            // 기본 동작: 프로젝트 상세 페이지로 이동
            if (userType === 'admin' || userType === 'contractor') {
              navigate(`/projects/${projectId}`);
            } 
            else if (result.allProjects && result.allProjects.length > 1 && userType === 'vip_customer') {
              // VIP 고객이고 프로젝트가 여러 개인 경우만 홈으로
              navigate('/');
            } 
            else {
              navigate(`/projects/${projectId}`);
            }
          }
        } else {
          toast.error(result.error || '접속에 실패했습니다.');
        }
      } catch (error) {
        toast.error('접속 중 오류가 발생했습니다.');
      } finally {
        setIsAccessing(false);
      }
    };

    handleAccess();
  }, [projectId, password, customerAccess, navigate, user, directToChat, directToHome]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            프로젝트 접속 중...
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            잠시만 기다려주세요
          </p>
        </div>
        <div className="flex justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
        </div>
      </div>
    </div>
  );
};

export default CustomerAccess;